import { RootState } from '../../store/root';
import { IAsyncError } from '../../common';

export const selectIsLoading = (state: RootState): boolean => state.followAuthor.isLoading;
export const selectError = (state: RootState): IAsyncError | undefined => state.followAuthor.error;
export const selectFolloweeIds = (state: RootState): string[] => state.followAuthor.followeeIds;
export const selectFolloweesFetchedAt = (state: RootState): Date | null => state.followAuthor.followeesFetchedAt;
export const selectIsFetchingFolloweeIds = (state: RootState): boolean => state.followAuthor.isFetchingFolloweeIds;
